import { PaymentPageType } from '@app/core/enums/payment-type.enum';
import { DynamicImportService } from '@app/core/services/dynamic-import/dynamic-import.service';

export class IndustryBuyingPaymentHandler {
  dialog:any
  dyis:DynamicImportService
  constructor(partial: Partial<IndustryBuyingPaymentHandler>) {
    Object.assign(this, partial);
  }

  async handle(initPaymentInfo: any): Promise<void> {
    if (initPaymentInfo?.pageType === PaymentPageType.REDIRECT) {
      this._getPaymentRedirectionUrl(initPaymentInfo)
    } else {
      console.log('Please add REDIRECT for payment completion.');
    }
  }

  private _getPaymentRedirectionUrl(initPaymentInfo:any): void {
    const paymentUrl = initPaymentInfo?.payment_links?.web ?? initPaymentInfo?.return_url;
    if (paymentUrl) {
      window.location.replace(paymentUrl);
    }
  }
}
